import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { TokenObject } from '../../api/baseApi';
import {
  REFRESH_TOKEN_COOKIE_KEY,
  ACCESS_TOKEN_COOKIE_KEY,
} from '../../constants';

export const NAMESPACE = 'user';

interface UserState {
  accessToken: string | null;
  refreshToken: string | null;
}

const initialState: UserState = {
  accessToken: Cookies.get(ACCESS_TOKEN_COOKIE_KEY) || null,
  refreshToken: Cookies.get(REFRESH_TOKEN_COOKIE_KEY) || null,
};

const userSlice = createSlice({
  name: NAMESPACE,
  initialState,
  reducers: {
    setTokenData: (state, action: PayloadAction<TokenObject>) => {
      const { accessToken, refreshToken, expiresIn } = action.payload;

      state.accessToken = accessToken;
      const accessTokenExpireDate = new Date(
        new Date().getTime() + expiresIn * 1000
      );
      Cookies.set(ACCESS_TOKEN_COOKIE_KEY, accessToken, {
        expires: accessTokenExpireDate,
      });

      state.refreshToken = refreshToken;
      Cookies.set(REFRESH_TOKEN_COOKIE_KEY, refreshToken, {
        expires: 14,
      });
    },
    deleteTokenData: (state) => {
      state.accessToken = null;
      Cookies.remove(ACCESS_TOKEN_COOKIE_KEY);

      state.refreshToken = null;
      Cookies.remove(REFRESH_TOKEN_COOKIE_KEY);
    },
  },
});

export const { actions, reducer } = userSlice;
